import { motion } from "framer-motion";
import { Scale, Clock, FileCheck, AlertTriangle } from "lucide-react";

const POINTS = [
  {
    icon: Scale,
    tag: "The Ruling",
    title: "6–3 Supreme Court Decision",
    body: "On Feb 20, 2026, the Supreme Court ruled IEEPA tariffs unlawful — from the moment they were imposed.",
  },
  {
    icon: FileCheck,
    tag: "Phase 1 Live",
    title: "CBP's CAPE portal is open",
    body: "Refunds are being processed now for unliquidated entries. Phase 2 has no confirmed timeline.",
  },
  {
    icon: Clock,
    tag: "Timeline",
    title: "60–90 days standard",
    body: "Standard CBP processing — or get advance funding immediately against your expected refund.",
  },
  {
    icon: AlertTriangle,
    tag: "Urgency",
    title: "Windows are closing",
    body: "Filing delays risk forfeiting recovery rights permanently. Section 122 tariffs expire July 23, 2026.",
  },
];

export default function Situation() {
  return (
    <section
      id="situation"
      data-testid="situation-section"
      className="section-light relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 lg:sticky lg:top-32"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#0A1936]" />
              <span className="font-mono uppercase tracking-[0.24em] text-[11px] text-[#0A1936]/70">
                01 · The Situation
              </span>
            </div>
            <h2 className="font-serif text-[#0A1936] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              A landmark ruling.
              <br />
              <span className="italic">A closing window.</span>
            </h2>
            <p className="mt-8 text-lg text-[#0A1936]/70 leading-relaxed max-w-md">
              The Supreme Court&apos;s February ruling opened the largest customs
              refund event in U.S. history —{" "}
              <span className="text-[#0A1936] font-semibold">
                $166B+ owed back to 301,000+ importers.
              </span>{" "}
              But the filing window won&apos;t stay open forever.
            </p>
          </motion.div>

          <div className="lg:col-span-7 space-y-5">
            {POINTS.map((p, i) => (
              <motion.article
                key={p.title}
                data-testid={`situation-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.65, delay: i * 0.08 }}
                className="group relative bg-white border border-[#0A1936]/10 hover:border-[#F5B800] rounded-md p-8 lg:p-10 transition-colors"
              >
                <div className="flex items-start gap-6">
                  <div className="shrink-0 w-12 h-12 rounded-sm bg-[#0A1936] group-hover:bg-[#F5B800] transition-colors flex items-center justify-center">
                    <p.icon
                      size={22}
                      className="text-[#F5B800] group-hover:text-[#0A1936] transition-colors"
                    />
                  </div>
                  <div className="flex-1">
                    <div className="font-mono uppercase tracking-[0.2em] text-[10px] text-[#0A1936]/50">
                      {p.tag}
                    </div>
                    <h3 className="font-serif text-2xl sm:text-3xl text-[#0A1936] mt-2 leading-tight">
                      {p.title}
                    </h3>
                    <p className="mt-3 text-[#0A1936]/70 leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
